import { ReactNode } from "react";
import { Tabs as MantineTabs } from "@mantine/core";

type TabsProps = {
  data: {
    title: string;
    content: ReactNode;
  }[];
};

const Tabs = ({ data }: TabsProps) => {
  if ((data ?? []).length === 0) {
    return null;
  }

  return (
    <MantineTabs defaultValue={data?.[0]?.title || undefined}>
      <MantineTabs.List>
        {data.map(item => {
          return (
            <MantineTabs.Tab value={item.title} key={item.title}>
              {item.title}
            </MantineTabs.Tab>
          );
        })}
      </MantineTabs.List>

      {data.map(item => {
        return (
          <MantineTabs.Panel value={item.title} key={item.title}>
            {item.content}
          </MantineTabs.Panel>
        );
      })}
    </MantineTabs>
  );
};

export default Tabs;
